import React from 'react';

import { useTranslation } from 'react-i18next';
import { UserOutput, UserStatus } from '@cnx-saas/common';
import { useDialog } from '@cnx-saas/common-fe';
import { useSnackbar } from '@cnx-saas/snackbar';
import { useUpdateUserByAdminMutation } from '../../../api/tenant/mutations/update-user-by-admin';
import { EditUserForm } from '../forms/EditUserForm';

export function useEditFormDialog(refetch: () => void) {
  const { t } = useTranslation();

  const { openDialog, closeDialog } = useDialog();
  const { addAlert } = useSnackbar();
  const [updateUser] = useUpdateUserByAdminMutation();
  function openEditFormDialog(user: UserOutput) {
    const id = 'edit-user-dialog';
    openDialog({
      id,
      title: t('registration.edit-user-dialog.title', {
        defaultValue: 'Edit user',
      }),
      content: (
        <EditUserForm
          user={user}
          onClose={() => closeDialog(id)}
          onSubmit={async (user) => {
            const response = await updateUser({
              variables: {
                details: {
                  email: user.email,
                  accountType: user.userType,
                  isActive: user.status === UserStatus.ACTIVE,
                },
              },
            });
            if (response.errors) {
              addAlert({
                type: 'error',
                children: response.errors.toString(),
              });
            } else {
              addAlert({
                type: 'success',
                children: t('registration.edit-user-dialog.success', {
                  defaultValue: 'Email has been sent',
                }),
              });
              closeDialog(id);
            }
            refetch();
          }}
        />
      ),
      fitsContent: true,
    });
  }
  return { openEditFormDialog };
}
